
export function transporttypeColor(type): string | "" {
   switch (type) {
      // Bus
      case 'Bus':
      case 'Natbus':
      case 'Telebus':
      case 'Bybus':
      case 'X Bus':
      case 'Havnebus':
      case 'Togbus':
      case 'Ekspresbus':
      case 'Flexbus':
      case 'Skolebus':
      case 'Metro-togbus':
      case 'N?rbus':
      case 'Sightseeing bus':
      case 'Ekstrabus':
      case 'Fjernbus':
      case 'F?rerl?s bus':
      case 'Flybus':
      case 'Traktorbus':
      case 'Letbane Togbus':
      case 'E-Bus':
      case 'C-Bus':
         return "Yellow"

      // Special bus
      case 'Flextur':
         return "Tomato"

      // Tog

      case 'IC':
      case 'ICL':
      case 'Re':
      case 'EC':
      case 'S-Tog':
      case 'Lokalbane':
      case 'RA':
      case 'RX':
      case 'EN':
      case 'P?gatog':
      case 'IR':
      case 'Nattog':
      case 'International':
      case 'ICE':
      case 'SJ':
      case 'InterCityNight':
      case 'IB':
      case 'Skoletog':
      case 'Materieltog':
      case 'ICL-X':
      case 'ICL+':
      case 'ServiceB':
      case 'R-net':
         return "Red"

      // Letbane / Metro
      case 'Letbane':
      case 'Metro':
         return "Darkblue"

      // Gang/Gå/Transit
      case 'Gang':
      case 'Gå':
      case 'Transit':
         return "Darkgrey" //Lyseren end "Grey"

      // Cykel
      case 'Cykel':
         return "Grey"

      // Bil/Taxi
      case 'Taxa':
      case 'Bil':
         return "#4d4d4d"

      // Fly
      case 'Fly':
         return "Black"

      // Færge
      case 'F?rge':
      case 'Hurtigf?rge':
         return "Blue"
   }
   return ""
}
